import { __generator } from "tslib";
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { setInitialHandoffZoomFlag, updateZoomPosition, } from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { PADDING, WIDTH } from '../constants/handoffSidebar';
import { getInitialZoom, isInHandoffMode, isInitialHandoffZoomSet, } from '../selectors/handoff';
import { getRenderedScreenDimensions } from '../selectors/screen';
export default function handoffZoomFit() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery([
                    actionTypes.LOAD_FULL_PROJECT_DONE,
                    actionTypes.FIT_ZOOM,
                    actionTypes.SHOW_HANDOFF,
                ], function (_a) {
                    var inHandoffMode, availableWidth, fittedZoom, _b, isInitialZoomSet;
                    var type = _a.type;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, select(isInHandoffMode)];
                            case 1:
                                inHandoffMode = _c.sent();
                                if (!inHandoffMode) {
                                    return [2 /*return*/];
                                }
                                if (!(type === actionTypes.SHOW_HANDOFF)) return [3 /*break*/, 3];
                                return [4 /*yield*/, take(actionTypes.SCREEN_RESIZED)];
                            case 2:
                                _c.sent();
                                _c.label = 3;
                            case 3: return [4 /*yield*/, call(getAvailableWidth)];
                            case 4:
                                availableWidth = _c.sent();
                                return [4 /*yield*/, select(getInitialZoom, availableWidth)];
                            case 5:
                                fittedZoom = _c.sent();
                                _b = type;
                                switch (_b) {
                                    case actionTypes.SHOW_HANDOFF: return [3 /*break*/, 6];
                                    case actionTypes.LOAD_FULL_PROJECT_DONE: return [3 /*break*/, 6];
                                    case actionTypes.FIT_ZOOM: return [3 /*break*/, 10];
                                }
                                return [3 /*break*/, 12];
                            case 6: return [4 /*yield*/, select(isInitialHandoffZoomSet)];
                            case 7:
                                isInitialZoomSet = _c.sent();
                                if (isInitialZoomSet) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, put(updateZoomPosition(fittedZoom))];
                            case 8:
                                _c.sent();
                                return [4 /*yield*/, put(setInitialHandoffZoomFlag())];
                            case 9:
                                _c.sent();
                                return [3 /*break*/, 12];
                            case 10: return [4 /*yield*/, put(updateZoomPosition(fittedZoom))];
                            case 11:
                                _c.sent();
                                return [3 /*break*/, 12];
                            case 12: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getAvailableWidth() {
    var renderedDimensions, availableWidth;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getRenderedScreenDimensions)];
            case 1:
                renderedDimensions = _a.sent();
                if (renderedDimensions.width < window.innerWidth) {
                    availableWidth = renderedDimensions.width - PADDING * 2;
                }
                else {
                    // We subtract the sidebar WIDTH here because it is animating so
                    // at the time if this calculation the screen width is larger than
                    // it will be when the sidebar is open.
                    availableWidth = renderedDimensions.width - WIDTH - PADDING * 2;
                }
                return [2 /*return*/, availableWidth];
        }
    });
}
